import * as React from "react";
import { gql, useQuery } from "@apollo/client";

import {
  FindLocationsFromCampaignsQuery,
  Location
} from "../../../../../schemaTypes";
import { newCampaignSubscription } from "../FindCommunitiesFromCampaigns";

export const findLocationsFromCampaignsQuery = gql`
  query FindLocationsFromCampaigns {
    findLocationsFromCampaigns {
      id
      city
    }
  }
`;

type NewCampaignSubscriptionResult = {
  newCampaign: Location;
};

export function useSubscribeToNewCampaignsLocation(subscribeToMore: any) {
  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newCampaignSubscription,
      updateQuery: (prev: any, { subscriptionData }: { subscriptionData: { data?: NewCampaignSubscriptionResult } }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findLocationsFromCampaigns: [
            ...prev.findLocationsFromCampaigns,
            subscriptionData.data.newCampaign
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);
}

export function useFindLocationsFromCampaigns() {
  const { data, loading, subscribeToMore } = useQuery<FindLocationsFromCampaignsQuery>(findLocationsFromCampaignsQuery);

  useSubscribeToNewCampaignsLocation(subscribeToMore);

  return {
    locations: data?.findLocationsFromCampaigns ?? [],
    loading
  };
}
